import { jsx, jsxs } from "react/jsx-runtime";
import { useId } from "react";
import QuestionMarkCircle from "@crehana/compass.icons.outline/QuestionMarkCircle";
import Search from "@crehana/compass.icons.outline/Search";
import { InputField } from "../../InputField/index.js";
import { TooltipWrapper } from "../../TooltipWrapper/index.js";
import { cn } from "../utils.js";
const sectionClassname = 'tw-gap-2 tw-flex tw-flex-wrap tw-justify-between tw-relative tw-items-center';
const Container = ({ children, actions, className, isSmallPadding })=>/*#__PURE__*/ jsx("div", {
        className: cn(isSmallPadding ? 'tw-pt-1.2 tw-px-1.2' : 'tw-py-2 tw-px-2.4', className),
        children: /*#__PURE__*/ jsxs("div", {
            className: sectionClassname,
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: "tw-flex tw-w-auto tw-gap-1.2 tw-flex-wrap sm:tw-flex-nowrap tw-items-center",
                    children: children
                }),
                /*#__PURE__*/ jsx("div", {
                    className: sectionClassname,
                    children: actions
                })
            ]
        })
    });
const Title = ({ title, helpLabel })=>{
    if (!title || !title) return null;
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-items-center",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "tw-font-subtitle5 dark:tw-text-neutral-light-100",
                children: title
            }),
            helpLabel && /*#__PURE__*/ jsx(TooltipWrapper, {
                containerClassName: "tw-ml-1 tw-text-center tw-whitespace-pre",
                message: helpLabel,
                position: "top",
                offset: 8,
                children: /*#__PURE__*/ jsx(QuestionMarkCircle, {
                    size: 24,
                    className: "tw-text-neutral-dark-800 dark:tw-text-neutral-dark-100"
                })
            })
        ]
    });
};
const Counter = ({ value })=>{
    if (!value) return null;
    return /*#__PURE__*/ jsx("div", {
        className: "dark:tw-bg-neutral-dark-700 tw-bg-neutral-light-400 tw-font-link1 py-2 tw-px-0.8 tw-rounded-0.4 tw-mr-1",
        children: value
    });
};
const Toolbar_Search = ({ input })=>{
    const autofillName = `table-search-${useId()}`;
    if (!input) return null;
    return /*#__PURE__*/ jsx("div", {
        className: "tw-w-full tw-max-w-[209px]",
        children: /*#__PURE__*/ jsx(InputField, {
            hideLabel: true,
            leadingIcon: Search,
            placeholder: input.placeholder,
            autoComplete: "new-password",
            name: autofillName,
            ...input,
            label: input.label || '',
            full: true,
            containerClassName: "tw-max-w-[209px]"
        })
    });
};
const Toolbar = ({ children, className })=>/*#__PURE__*/ jsx("div", {
        className: className,
        children: children
    });
Toolbar.Container = Container;
Toolbar.Title = Title;
Toolbar.Counter = Counter;
Toolbar.Search = Toolbar_Search;
const Toolbar_Toolbar = Toolbar;
export default Toolbar_Toolbar;
export { Container, Title, Toolbar };
